import { ReactComponent as DeleteIcon } from '../../../../assets/img/DeleteMaskIcon.svg';
import { ReactComponent as RedCross } from '../../../../assets/img/icons/redCrossSmall.svg';
import SelectWithIcon from 'modules/Campaigns/Shared/SelectWithIcon';
import LinkCampaignSelectInput from '../Components/LinkCampaignSelectInput';
import { IActionData } from '../interfaces';
import { useState } from 'react';
import styled from 'styled-components';
import SelectAnt from '../Components/SelectAnt';
import { IListItemNames } from 'modules/Audience/interface';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  .space {
    margin-right: 12px;
    width: 191px;
    @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
      width: 130px !important;
    }
  }
`;

type Props = {
  action: IActionData;
  actionIndex: number;
  onChangeActionType: (index: number, value: string) => void;
  onChangeCheckbox: (val: boolean, index: number, listId: number, listName: string, action: IActionData) => void;
  listDataNames: IListItemNames[];
  listDataNamesLoading: boolean;
  onClickCreateList: (listName: string) => void;
  setisOpenDeletePopup: (val: boolean) => void;
  setTempObj: (obj: { index: number; isAction: boolean; action: IActionData }) => void;
  deleteActionHandler: (index: number, action: IActionData) => void;
  newListAdded: boolean;
  setNewListAdded: (val: boolean) => void;
  newListActionIndex: number;
  setNewListActionIndex: (val: number) => void;
};

const FormSubmission = (props: Props) => {
  const {
    action,
    actionIndex,
    onChangeActionType,
    onChangeCheckbox,
    listDataNames,
    listDataNamesLoading,
    onClickCreateList,
    setisOpenDeletePopup,
    setTempObj,
    deleteActionHandler,
    newListAdded,
    setNewListAdded,
    newListActionIndex,
    setNewListActionIndex,
  } = props;
  const key = Object.keys(action)[0];
  const value = Object.values(action)[0];
  const listNames = (action['list_names'] as string)?.split(',');
  const listIds = (value as string)?.toString()?.split(',');
  const updatedListIds: number[] = listIds?.map((id) => Number(id));
  const actionTypes = [{ value: 'Add to list', label: 'Add to list' }];
  const [selectedOption, setSelectedOption] = useState(key);

  return (
    <>
      {/* Action Type */}
      <Wrapper className="form-submission-wrapper">
        <span className="space">
          <SelectWithIcon
            defaultValue={{ value: 'Select Action', label: 'Select Action' }}
            options={actionTypes}
            onChange={(e) => {
              onChangeActionType(actionIndex, e.value);
              setSelectedOption(e.value);
            }}
            value={{ value: selectedOption, label: selectedOption }}
            className="add-list"
            menuWidth={170}
            disabled={false}
          />
          {/* <SelectAnt disabled={false} options={options} defaultValue="Last Name" /> */}
        </span>
        {/* Lists Listing */}
        <LinkCampaignSelectInput
          inList={true}
          isCheckbox={true}
          action={action}
          actionIndex={actionIndex}
          listsData={listDataNames}
          listDataNamesLoading={listDataNamesLoading}
          onChangeListCheckbox={onChangeCheckbox}
          selectedListNames={listNames}
          selectedListIds={updatedListIds}
          onClickCreateList={onClickCreateList}
          newListAdded={newListAdded}
          setNewListAdded={setNewListAdded}
          newListActionIndex={newListActionIndex}
          setNewListActionIndex={setNewListActionIndex}
        />
        {/* Delete Button */}
        <span
          id="delete-mask-icon"
          onClick={() => {
            if (value !== '' && key !== 'Select Action') {
              setisOpenDeletePopup(true);
              setTempObj({ index: actionIndex, isAction: true, action: action });
            } else {
              deleteActionHandler(actionIndex, action);
            }
          }}
        >
          {value !== '' && key !== 'Select Action' ? <DeleteIcon /> : <RedCross />}
        </span>
      </Wrapper>
    </>
  );
};

export default FormSubmission;
